
import { WelcomeInitializer as GlobalWelcomeInitializer } from '@teamworks/global';

export class WelcomeInitializer {

  static initialize() {
    GlobalWelcomeInitializer.initialize();
  }
}
